import React, { useRef, useState } from 'react';

import styled from '@emotion/styled';
import copy from 'copy-to-clipboard';
import { darken } from 'polished';
import Tooltip from '@vromo/ui/components/Tooltip';
import theme from '@vromo/ui/components/theme';
import { useToasts } from '@vromo/ui/components/Toasts';
import Input from '@vromo/ui/components/Input';
import FontAwesome from './FontAwesome';

const Button = styled.button`
    padding: 8px 10px;
    height: 100%;
    background-color: ${theme.primary};
    border: none;
    color: white;
    font-size: 14px;
    border-radius: 0px 5px 5px 0px;

    &:hover {
        background-color: ${darken(0.05, theme.primary)};
    }

    &:focus {
        outline: 0;
    }
`;

type Props = {
    value: string;
    toastMessage: string;
};

export default function Clipboard({ value, toastMessage }: Props) {
    const input = useRef();
    const showToast = useToasts();

    function focus() {
        if (input.current) input.current.focus();
    }

    function copyValue() {
        copy(value);
        showToast(toastMessage, 'success');
    }

    return (
        <div style={{ position: 'relative' }}>
            <Input
                style={{ margin: 0, color: theme.mediumGrey, borderColor: theme.grey }}
                type="text"
                ref={input}
                value={value}
                onChange={() => {}}
                onClick={focus}
            />
            <div style={{ position: 'absolute', top: 0, right: 0, height: '100%' }}>
                <Tooltip label="Copy to clipboard" position="bottom">
                    <Button onClick={copyValue}>
                        <FontAwesome
                            icon="clipboard"
                            weight="regular"
                            style={{ paddingLeft: 15, paddingRight: 15 }}
                        />
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
}
